<template>
    <div class="col-md-6 ">
        <b-card class="shadow mb-5" no-body>
            <b-card-header>Liste des missions activées</b-card-header>
            <b-card-body>
                <b-button
                    v-if="quotation!==null"
                    size="sm"
                    variant="primary"
                    block
                    class="mb-3"
                    @click="resetMissions"
                >
                    <i class="far fa-sync-alt mr-2"/>Remplacer ces missions par celles validées dans le dernier devis
                    accepté
                </b-button>
                <source-mission-family-card
                    v-for="sourceMissionFamily in sourceMissionFamilies"
                    :key="'smf' + sourceMissionFamily.id + key"
                    :source-mission-family="sourceMissionFamily"
                    :client-id="client"
                />
            </b-card-body>
        </b-card>
    </div>
</template>
<script>
import SourceMissionFamilyCard from '../components/missions/SourceMissionFamilyCard.vue'
import ToastHandler from '../../invoicing/mixins/ToastHandler.vue'
import KeyHandler from '../../invoicing/mixins/KeyHandler.vue'

export default {
    name: 'MissionCard',

    components: {
        SourceMissionFamilyCard,
    },

    mixins: [ToastHandler, KeyHandler],

    props: {
        client: {
            required: true,
            type: Number,
        },
    },

    data() {
        return {
            sourceMissionFamilies: [],
            quotation: null
        }
    },

    async created() {
        await this.getSourceMissionFamilies()
        await this.getLastAcceptedQuotation()
    },

    methods: {
        async getSourceMissionFamilies() {
            try {
                const response = await this.$axios.get(
                    `clients/${this.client}/sourceMissionFamilies`
                )
                this.sourceMissionFamilies = response.data.data
            } catch (error) {
                //
            }
        },

        async getLastAcceptedQuotation() {
            try {
                const response = await this.$axios.get(
                    `clients/${this.client}/lastAcceptedQuotation`
                )
                this.quotation = response.data.data
            } catch (error) {
                //
            }
        },

        async resetMissions() {
            this.showProcessingToast()
            try {
                const response = await this.$axios.put(
                    `clients/${this.client}/resetMissions`
                )
                this.handleRecordingResponse(response.data.meta)
                this.updateKey()
            } catch (error) {
                //
            }
        },
    },
}
</script>
<style scoped></style>
